import CONSTANTS from '../../lib/constants.js';
import { compileSchema, toEnumSchema } from 'ui-core';

/** @type {import('json-schema').JSONSchema7} */
let schema = {
	type: 'object',
	required: ['channelId', 'title'],
	properties: {
		channelId: toEnumSchema(CONSTANTS.PushNotificationChannels),
		title: { type: 'string' },
		message: { type: 'string' },
	},
	dependencies: {
		channelId: {
			oneOf: [
				{
					required: ['experienceId'],
					properties: {
						channelId: { enum: [CONSTANTS.PushNotificationChannels.Live] },
						image: { $ref: '#/definitions/imageUrl' },
						experienceId: {$ref: '#/definitions/MongoObjectID'}
					}
				},
				{
					properties: {
						channelId: { enum: [CONSTANTS.PushNotificationChannels.FeaturedExperiences] },
						image: { $ref: '#/definitions/imageUrl' },
						experienceId: {$ref: '#/definitions/MongoObjectID'},
						expFeedId: {$ref: '#/definitions/MongoObjectID'}
					},
					if: {
						properties: {
							experienceId: {const: ''}
						}
					},
					then: {
						required: ['expFeedId'],
						properties: {
							expFeedId: {$ref: '#/definitions/MongoObjectID'}
						}
					}
				},
				{
					properties: {
						channelId: { enum: [CONSTANTS.PushNotificationChannels.FeaturedSpaces] },
					},
					additionalProperties: false
				},
				{
					properties: {
						channelId: { enum: [CONSTANTS.PushNotificationChannels.Other] },
						image: { $ref: '#/definitions/imageUrl' }
					}
				}
			]
		}
	}
};

let uiSchema = {
};

schema = compileSchema(schema);
export { schema, uiSchema };
